<template>
  <div class="minwidth w100 mw100">
    <tabbar></tabbar>

    <div class="positionrel w100">
      <img :src="require('../../public/img/join/pic1.png')" class="positionabs" />
      <div style="color: #fff;font-size: 3rem;position: absolute;top: 8rem;left: 50%;transform: translate(-50%);">
        注册
      </div>
    </div>

    <div class="form-wrap">
      <div class="form-row">
        <div class="form-label">账号：</div>
        <input v-model.trim="form.account" class="form-input" type="text" placeholder="请输入账号" />
      </div>
      <div class="form-row">
        <div class="form-label">密码：</div>
        <input v-model="form.password" class="form-input" type="password" placeholder="请输入密码" />
      </div>
      <div class="form-row">
        <div class="form-label">姓名：</div>
        <input v-model.trim="form.name" class="form-input" type="text" placeholder="您的姓名" />
      </div>
      <div class="form-row">
        <div class="form-label">邮箱：</div>
        <input v-model.trim="form.email" class="form-input" type="text" placeholder="您的邮箱" />
      </div>
      <div class="form-row">
        <div class="form-label">电话：</div>
        <input v-model.trim="form.phone" class="form-input" type="text" placeholder="您的电话" />
      </div>

      <agreement v-model="agreed"></agreement>

      <div class="form-btn" @click="handleRegister">注册</div>
      <div class="form-link" @click="gotoLogin">已有账号，去登录 ></div>
    </div>

    <bottom></bottom>
  </div>
</template>

<script>
import { register } from '../utils/auth'

export default {
  data() {
    return {
      agreed: false,
      form: {
        account: '',
        password: '',
        name: '',
        email: '',
        phone: '',
      },
    }
  },

  methods: {
    handleRegister() {
      const { account, password, name, email, phone } = this.form
      if (!account || !password || !name || !email || !phone) {
        this.$message.warning('请填写完整注册信息')
        return
      }
      if (!this.agreed) {
        this.$message.warning('请先阅读并同意服务协议与用户隐私说明')
        return
      }
      const res = register({ account, password, name, email, phone })
      if (!res.ok) {
        this.$message.error(res.message)
        return
      }
      this.$message.success(res.message)
      this.$router.push('/')
    },
    gotoLogin() {
      this.$router.push({ path: '/login' })
    },
  },
}
</script>

<style scoped>
.w100 {
  width: 100%;
}

.w60 {
  width: 60%;
}

.minwidth {
  min-width: 1000px;
}

.form-wrap {
  width: 36%;
  margin: 0 auto;
  padding: 2rem 0 3rem;
}

.form-row {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
}

.form-label {
  width: 22%;
  text-align: right;
  padding-right: 10px;
  box-sizing: border-box;
}

.form-input {
  width: 60%;
  display: block;
  height: 1.8rem;
  padding: 0 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-btn {
  width: 85%;
  margin: 1rem auto 0;
  text-align: center;
  background-color: #4571DB;
  height: 2.5rem;
  line-height: 2.5rem;
  border-radius: 1rem;
  color: #fff;
  cursor: pointer;
}

.form-btn:hover {
  opacity: 0.9;
}

.form-link {
  text-align: center;
  margin-top: 1.5rem;
  color: #888888;
  cursor: pointer;
}

.positionrel {
  position: relative;
  height: 340px;
  overflow: hidden;
}

.positionabs {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 1920px;
  -webkit-filter: contrast(50%);
  filter: contrast(50%);
}

@media screen and (max-width: 750px) {
  .minwidth {
    min-width: 0px;
  }

  .mw100 {
    width: 100vw;
  }

  .form-wrap {
    width: 88%;
  }

  .form-label {
    width: 28%;
  }

  .form-input {
    width: 68%;
  }

  .positionrel {
    position: relative;
    height: 179px;
    overflow: hidden;
  }

  .positionabs {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 780px;
  }
}
</style>
